var React = require('react');

function Certs (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(3.3333333333333335,0,0,3.3333333333333335,0,0)"},[React.createElement("path",{"d":"M17.5 7L11.465 15.732 6.887 11.152","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2,3.775v7.637A12.285,12.285,0,0,0,9.828,22.88l1.067.414a3.063,3.063,0,0,0,2.21,0l1.067-.414A12.285,12.285,0,0,0,22,11.412V3.775a1.536,1.536,0,0,0-.89-1.406A22.143,22.143,0,0,0,12,.5,22.143,22.143,0,0,0,2.89,2.369,1.536,1.536,0,0,0,2,3.775Z","fill":"none","stroke":"#da1884","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Certs.defaultProps = {"version":"1.1","xmlnsSvgjs":"http://svgjs.com/svgjs","viewBox":"0 0 80 80","width":"80","height":"80"};

module.exports = Certs;

Certs.default = Certs;
